import { FormDefinition } from "../../Components/Form/Form";
import { basic_text_validator, selection_validator } from "../formFieldValidators";
import { founderProgramDetailsFormDefinition } from "./founderProfileBase";

export const programDetailsFormDefinition: FormDefinition = {
  ...founderProgramDetailsFormDefinition,
  tier: {
    label: "Tier",
    frLabel: "Niveau",
    inputType: "dropdownSelect",
    validator: selection_validator,
    additionalData: {
      selectionData:[
        {
          value: "1",
          text: "1",
          frText: "Niveau 1"
        },
        {
          value: "2",
          text: "2",
          frText: "Niveau 2"
        },
        {
          value: "3",
          text: "3",
          frText: "Niveau 3"
        }
      ]
    }  
  },
  ownerName: {
    label: "Service Owner",
    frLabel: "Propriétaire du service",
    inputType: "text",
    tooltip: {
      content: "The current version of the App does not support changing service owners. Please contact support for more information. <br> If you are the owner of the service, go to <a href='/dashboard/profile'>Profile</a> and updating your name will also reflect here.",
      position: "top-left"
    },
    frTooltip: {
      content: "La version actuelle de l’application n’autorise pas le changement de propriétaire du service. Pour plus d’information, veuillez communiquer avec le Service de soutien. Si vous êtes le propriétaire du service, allez à Profil et la mise à jour de votre nom sera également rapportée ici.",
      position: "top-left"
    },
    validator: basic_text_validator,
    isViewOnly: true,
  },
  programRegion: {
    label: "Service Region",
    frLabel: "Région de service",
    inputType: "dropdownSelect",
    validator: {
      required: {
        value: true,
        message: "Please select an option",
        frMessage: "Veuillez sélectionner une option"
      }
    },
    additionalData: {
      selectionData: [
        {
          value: "communitech",
          text: "Communitech",
          frText: "Communitech"
        },
        {
          value: "northForge",
          text: "North Forge",
          frText: "North Forge"
        },
        {
          value: "investOttawa",
          text: "Invest Ottawa",
          frText: "Investir Ottawa"
        }
      ]
    },
  },
  lang: {
    label: "Language",
    frLabel: "Langue",
    inputType: "dropdownSelect",
    additionalData: {
      selectionData:[
        {
          value: "eng",
          text: "Eng",
          frText: "Anglais",
        },
        {
          value: "fr",
          text: "Fr",
          frText: "Français",
        },
      ]
    }
  },
  reportingCategory: {
    label: "Reporting Category",
    inputType: "dropdownSelect",
    frLabel: "Catégorie de rapport",
    validator: selection_validator,
    additionalData: {
      selectionData:[
        {
          value: "baiEducation",
          text: "BAI Education",
          frText: "Formation IAA (Incubateur Accélérateur d’Affaires)"
        },
        {
          value: "generalAwareness",
          text: "General Awareness",
          frText: "Sensibilisation générale"
        },
        {
          value: "onlineModules",
          text: "Online Modules",
          frText: "Modules en ligne"
        },
        {
          value: "otherBaiEducation",
          text: "Other - BAI Education",
          frText: "Autre - Formation IAA"
        },
        {
          value: "otherStartupEducation",
          text: "Other - Startup Education",
          frText: "Autre - Formation pour entreprise en démarrage"
        },
        {
          value: "seminars",
          text: "Seminars",
          frText: "Séminaires"
        },
        {
          value: "webinars",
          text: "Webinars",
          frText: "Webinaires"
        },
        {
          value: "workshops",
          text: "Workshops",
          frText: "Ateliers"
        },
        {
          value: "assessment",
          text: "Assessment",
          frText: "Évaluation"
        },
        {
          value: "coachingAndAdvisory",
          text: "Coaching & Advisory",
          frText: "Mentorat et conseil"
        },
        {
          value: "commercialization",
          text: "Commercialization",
          frText: "Commercialisation"
        },
        {
          value: "other",
          text: "Other",
          frText: "Autre"
        },
        {
          value: "patent",
          text: "Patent",
          frText: "Brevet"
        },
        {
          value: "trademark",
          text: "Trademark",
          frText: "Marque de commerce"
        },
        {
          value: "copyrightRegistration",
          text: "Copyright Registration",
          frText: "Enregistrement de droits d’auteur"
        },
        {
          value: "patentApplication",
          text: "Patent Application",
          frText: "Application de brevet"
        },
        {
          value: "trademarkRegistration",
          text: "Trademark Registration",
          frText: "Enregistrement de marque de commerce"
        },
      ],
    }
  },
  deliverables: {
    label: "Deliverables",
    frLabel: "Livrables",
    inputType: "text",
    validator: basic_text_validator
  },
  notes: {
    label: "Notes",
    frLabel: "Remarques",
    inputType: "textarea",
    validator: basic_text_validator
  },
  isCoPay: {
    label: "Co-Pay Service",
    frLabel: "Service de co-paiement",
    tooltip: {
      content: "Startups receiving funding to implement their IP strategy will be required to co-invest at a minimum 10-35% of eligible costs.",
      position: "top-right"
    },
    frTooltip: {
      content: "Les startups recevant un financement pour mettre en œuvre leur stratégie de propriété intellectuelle devront co-investir au minimum 10 à 35 % des coûts éligibles.",
      position: "top-right"
    },
    inputType: "boolean",
  },
  isRequiringAttestation: {
    label: "This service requires founders to check attestation.",
    frLabel: "Ce service exige que les fondateurs vérifient l’attestation",
    inputType: "boolean",
  },
  applicationFormDefinition: {
    label: "Application Form Definition",
    frLabel: "Définitions du formulaire d’application",
    inputType: "formDefinition",
  },
  lockedContent: {
    label: "Locked Content - input in HTML, dev ovnly please",
    frLabel: "Contenu verrouillé - entrée en HTML, dév. seulement",
    inputType: "textarea",
  }
}
